import { backendVersion,globalAxios } from "@/axios-path.js";

export default {
  namespaced: true,
  state: {
    package_data: [],
    package_list: []
  },
  mutations: {
    getData(state, data) {
      state.package_data = data;
    },
    getPackageList(state, data) {
      state.package_list = data;
    },
    delPackage(state, data) {
      let index = state.package_list.indexOf(data);
      state.package_list.splice(index, 1);
    },
    addPackage(state, data) {
      state.package_list.push(data);
    },
    editPackage(state, data) {
      let index = state.package_list.indexOf(data.original);
      Object.assign(state.package_list[index], data.res);
    }
  },
  actions: {
    async editPackage({ commit, rootState, dispatch }, form) {
      let url =
        rootState.api_urls.fetchPackageBack_editPackage + form.package_id;
      let res = await dispatch(
        "fetchGeneral/axiosPathPutData",
        { url, form },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        let send_data = {
          res: res,
          original: form
        };
        commit("editPackage", send_data);
      }
    },
    async addPackage({ commit, rootState, dispatch }, form) {
      let url = rootState.api_urls.fetchPackageBack_addPackage;
      let res = await dispatch(
        "fetchGeneral/axiosPathPostData",
        { url, form },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
      } else {
        commit("addPackage", res);
      }
    },
    async delPackage({ commit, rootState, dispatch }, data) {
      let url =
        rootState.api_urls.fetchPackageBack_delPackage + data.package_id;
      let res = await dispatch("fetchGeneral/axiosPathDeleteData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("delPackage", data);
      }
    },
    async getData({ commit, rootState, dispatch }) {
      let url = rootState.api_urls.fetchPackageBack_getData;
      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
        return 3;
      } else {
        commit("getData", res);
        return res;
      }
    },
    async getPackageList({ commit, rootState, dispatch }, { province_name }) {
      let url = `/api/v1/${province_name}/show/detail/packages`;
       return globalAxios
        .get(url)
         .then(res => {
          commit("getPackageList", res);
          return res;
        })
        .catch(err => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
    async getPackageByProvince({ dispatch }, province) {
      let url = `${backendVersion.version}/${province}/show/detail/packages`
      let res = await dispatch("fetchGeneral/coreInstanceGetData", url, {
        root: true
      });
      if (res === false) {
        return false;
      } else {
        console.log(res);
        return res;
      }
    }
  },
  getters: {}
};
